import useLazyQuery from "../useLazyQuery"

export const useDeleteRoleQuery = (roleId = "Error") => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/roles/${roleId}`
	return useLazyQuery<void, void>(url, "DELETE")
}
